<template>
    <div class="manufacturer-grid-container">
        <div class="manufacturer-info-container">
            <div class="manufacturer-card-one bg">
                <div
                    v-for="(progressItem, progressIndex) in data.progressList"
                    :key="progressIndex"
                    class="manufacturer-donghua-container"
                >
                    <!-- <CommonComponentsSolutionsManufacturerReuseProgressBar
                        :progress-item="progressItem"
                        :progress-index="progressIndex"
                        :class="`progress-${progressIndex}`"
                    /> -->
                    <!-- <CommonComponentsSolutionsManufacturerReuseProgressBar2
                        :progress-item="progressItem"
                        :progress-index="progressIndex"
                        :class="`progress-${progressIndex}`"
                    /> -->
                    <CommonComponentsSolutionsManufacturerReuseProgressBar3
                        :progress-item="progressItem"
                        :progress-index="progressIndex"
                        :class="`progress-${progressIndex}`"
                    />
                </div>
            </div>
            <div class="manufacturer-tip">
                <span>{{ $t('global_solutions_manufacturer_Arrows_describe_9') }}</span>
            </div>
        </div>
    </div>
    <!-- <div class="manufacturer-video bg">
        <div class="manufacturer-arrows-video">
            <CommonComponentsVideoPlayer
                class="video"
                :sources="[
                    {
                        src: data.path,
                        type: 'video/mp4',
                    },
                ]"
                :poster="data.poster"
            />
        </div>
        <div class="video-bottom-text">
            {{ $t(data.videoBottomText) }}
        </div>
    </div> -->
</template>

<script setup lang="ts">
    import path from '@assets/Video/solutions/manufacturer/3.mp4';
    import poster from '@assets/Video/solutions/manufacturer/3.jpg';
    const data = reactive({
        videoBottomText: 'global_solutions_manufacturer_arrows_video_bottom_text',
        path,
        poster,
        progressList: [
            // {
            //     title: 'global_solutions_manufacturer_arrows_card_title_1',
            //     subTitle: '55',
            //     num: 4,
            // },
            // {
            //     title: 'global_solutions_manufacturer_arrows_card_title_2',
            //     subTitle: '36',
            //     num: 2,
            // },
            // {
            //     title: 'global_solutions_manufacturer_arrows_card_title_3',
            //     subTitle: '24',
            //     num: 1,
            // },
            {
                title: 'global_solutions_manufacturer_arrows_progressbar_title_0',
                text: 'global_solutions_manufacturer_arrows_progressbar_text_0',
                hour: 'global_solutions_manufacturer_arrows_progressbar_bluetext_0',
                tiemsnum: 16.8,
            },
            {
                title: 'global_solutions_manufacturer_arrows_progressbar_title_1',
                text: 'global_solutions_manufacturer_arrows_progressbar_text_1',
                hour: 'global_solutions_manufacturer_arrows_progressbar_bluetext_1',
                tiemsnum: 42,
            },
            {
                title: 'global_solutions_manufacturer_arrows_progressbar_title_2',
                text: 'global_solutions_manufacturer_arrows_progressbar_text_2',
                hour: 'global_solutions_manufacturer_arrows_progressbar_bluetext_2',
                tiemsnum: 60,
            },
        ],
    });

    onMounted(() => {
        addFadeIn('.vs');
    });
</script>

<style lang="less" scoped>
    .manufacturer-grid-container {
        flex-shrink: 0;
        display: flex;
        // flex-direction: column;
        justify-content: center;

        font-family: Montserrat, 'HarmonyOS Sans SC';
        .manufacturer-info-container {
            width: 100%;
            // width: .convert(1200px) [ @vw];
            font-size: .convert(32px) [ @vw];
            // height:.convert(500px)[@vw];
            line-height: 160%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            background: #262626;
            border-radius: 20px;
            padding: .convert(20px) [ @vw];
            @media (max-width: @screen-mobile-width) {
                width: 100%;
            }

            .manufacturer-tip {
                line-height: 14px;
                color: rgba(100, 100, 100, 1);
                font-size: 14px;
                padding-left: .convert(120px) [ @vw];
                margin-bottom: 30px;
                @media (max-width: @screen-mobile-width) {
                    padding-left: .convert(60px) [ @vw];
                    font-size: 12px;
                    margin-top: 0px;
                    margin-bottom: 10px;
                }
            }

            .manufacturer-card {
                &-one {
                    display: flex;
                    // padding: .convert(74px) [ @vw] .convert(0px) [ @vw] .convert(89px-56px) [ @vw] .convert(34px) [
                    //     @vw];
                    flex-flow: row;
                    justify-content: center;

                    @media (max-width: @screen-mobile-width) {
                        display: flex;
                        // flex-flow: nowrap;
                        flex-direction: column;
                    }

                    .manufacturer-donghua-container {
                    }

                    .progress-2,
                    .progress-1 {
                        position: relative;
                    }
                    .progress-2::before,
                    .progress-1::before {
                        content: '';
                        position: absolute;
                        top: .convert(64px) [ @vw];
                        height: .convert(270px) [ @vw];
                        width: 1px;
                        background-color: rgba(255, 255, 255, 0.4);
                        @media (max-width: @screen-mobile-width) {
                            background-color: rgba(255, 255, 255, 0.2);
                            top: 0px;
                            left: 20px;
                            width: 305px;
                            height: 1px;
                        }
                    }
                }
            }
        }
    }
    .manufacturer-video {
        margin: auto;
        margin-top: .convert(47px) [ @vw];
        @media (max-width: @screen-mobile-width) {
            // margin-top: .convert(30px) [ @vh];
        }
        .manufacturer-arrows-video {
            .video {
                height: .convert(670px) [ @vw];
                @media (max-width: @screen-mobile-width) {
                    height: .convert(193px) [ @vw-mobile] !important;
                }
            }
        }
        .video-bottom-text {
            font-family: 'HarmonyOS Sans SC';
            font-size: .convert(@font-size-xl) [ @vw]; //24
            text-align: center;
            margin-top: .convert(16px) [ @vw];
            @media (max-width: @screen-mobile-width) {
                font-size: 12px;
            }
        }
    }
</style>
